import datepicker from 'js-datepicker';
import Blue from "~/core";

new Blue({
  name: 'Date Picker',
  selector: ".datePicker",
  setup(element) {
    var minDate = new Date();
    minDate.setDate(minDate.getDate() + 1);

    const picker = datepicker(element, {
      minDate: minDate,
      formatter: (input, date, instance) => {
        let value = date.toLocaleDateString();// => '1/13/2099'
				let dateformat = input.getAttribute("data-dateformat");
        if(dateformat != null){
          switch(dateformat.toLowerCase()){
            case "mm/dd/yyyy":
              value = 
								(date.getMonth()+1 < 10 ? `0${date.getMonth()+1}` : (date.getMonth()+1)) + "/" + 
								(parseInt(date.getDate()) < 10 ? `0${date.getDate()}` : date.getDate()) + "/" + 
								date.getFullYear(); // '09/09/2023' or 12/12/2021
            break;
          }
        }
        input.value = value;
    	},
      onSelect: (instance, date) => {
				element.focus();
				element.blur();
				document.body.click();
        if (window.innerWidth <= 414) {
          const yOffset = -100;
          let y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;

          window.scrollTo({
            top: y,
            behavior: 'smooth'
          });
        }
      }
    });
		
		this.$addEvents(element, 'focus', () => {
			const errors = [...document.querySelectorAll('.formError')];
			if (window.innerWidth <= 414 && errors.length < 1) {
				const yOffset = -100;
				let y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
				
				window.scrollTo({
					top: y,
					behavior: 'smooth'
				});
			}
		});

		this.$addEvents(element, 'keydown paste focus', (e) => {
			if(e.keyCode != 9) {
				e.preventDefault();
			}
		});
  }
});